import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/global.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

// 引入nprogress
import NProgress from 'nprogress'
import 'nprogress/nprogress.css' //这个样式必须引入

//v-view  图片放大
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
//移动端初始化文件
import 'normalize.css/normalize.css'


import VueAwesomeSwiper from 'vue-awesome-swiper'

// import style
import 'swiper/swiper-bundle.min.css'

Vue.use(VueAwesomeSwiper)
//懒加载
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: './assets/image_m/timg.gif',

})
Vue.use(Viewer)
Viewer.setDefaults({

  Options: { 'navbar': false, 'toolbar': false }
})

// 简单配置加载进度条
NProgress.inc(0.2)
NProgress.configure({ easing: 'ease', speed: 500, showSpinner: false })


router.beforeEach((to, from, next) => {
  NProgress.start()
  next()
})


//路由跳转后定到页面顶部
router.afterEach(route => {
  window.scrollTo(0, 0)
  NProgress.done()

})
Vue.use(ElementUI);

//pc端全局组件
import TabBar from './components/TabBar.vue'
Vue.component('TabBar', TabBar)
import Footer from './components/Footer.vue'
Vue.component('Footer', Footer)

//手机端全局组件
import TabBar_m from './mobile/Tabbar-m.vue'
Vue.component('TabBar_m', TabBar_m)
import Footer_m from './mobile/Footer-m.vue'
Vue.component('Footer_m', Footer_m)


Vue.config.productionTip = false



new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

